"use client";

import { useEffect } from "react";
import type { ReactNode } from "react";
import { useRouter } from "next/navigation";
import { useTranslation } from "react-i18next";

import { usePaymentsAccess } from "@/hooks/usePaymentsAccess";

const FALLBACK_ROUTE = "/transfers";

type Props = {
  children: ReactNode;
};

export default function PaymentsAccessGuard({ children }: Props) {
  const router = useRouter();
  const { t } = useTranslation();
  const { isUserLoaded, canAccessPayments } = usePaymentsAccess();

  useEffect(() => {
    if (isUserLoaded && !canAccessPayments) {
      router.replace(FALLBACK_ROUTE);
    }
  }, [isUserLoaded, canAccessPayments, router]);

  // Tant que l'utilisateur n'est pas chargé, ses rôles sont inconnus : afficher
  // la page reviendrait à l'ouvrir à tous le temps du chargement.
  if (!isUserLoaded || !canAccessPayments) {
    return (
      <div className="flex h-[60vh] items-center justify-center">
        <p className="text-sm text-default-500">
          {t("paymentsReceived.states.loading")}
        </p>
      </div>
    );
  }

  return <>{children}</>;
}
